import axios from "axios"
import { carsGetAxios } from "./carsGetAxios";


export function carsPutAxios(carsData) {
        return async function carsPutThunk(dispatch, getState) {
            await axios.put(`/api/cars/${carsData?.carId + '?use_status=' + carsData?.use_status}`, carsData)
            dispatch(carsGetAxios())
        };
    }